
import React from "react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function AgentRuntimeError() {
  const navigate = useNavigate();

  return (
    <div className="container mx-auto p-4 md:p-6">
      <Button variant="outline" className="mb-6" onClick={() => navigate(-1)}>
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back
      </Button>
      
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription>
          Agent not found. The agent you're trying to access might not exist or you don't have permission to view it.
        </AlertDescription>
      </Alert>
    </div>
  );
}
